import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';

import { Input } from 'components/bootstrap';

import { FormDataContext } from './context/FormData';
import { AdvancedOptionsContext } from './context/AdvancedOptions';
import type { HandleFieldUpdateType, FormDataContextType, AdvancedOptionsContextType } from './types';

interface Props {
  onChange: HandleFieldUpdateType;
}

const FormAdvancedOptions = ({ onChange }: Props) => {
  const { formData } = useContext<FormDataContextType>(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { awsSecurityLakeThrottleEnabled, awsSecurityLakeStoreFullMessage } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox
        id="awsSecurityLakeThrottleEnabled"
        defaultChecked={awsSecurityLakeThrottleEnabled?.value}
        onChange={onChange}
      />

      <Input
        id="awsSecurityLakeStoreFullMessage"
        type="checkbox"
        value="enable-storeFullMessage"
        defaultChecked={awsSecurityLakeStoreFullMessage?.value}
        onChange={onChange}
        label="Store Full Message"
        help="Store the full original Security Lake message as full_message?"
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
